import { useFeature } from "@hackler/react-sdk"

export function useHackleFeatureFlags() {
  return {
    webinarRequestOn: useFeature(33),
    boucherBannerOn: useFeature(70),
    shownFunnelBetaBadge: useFeature(85) === false,
  }
}
